'use client'

import type { ISxProps } from '@/CommonComponents/types'
import { Card as MUICard } from '@mui/material'
interface ICardProps {
  sx?: ISxProps
  children: React.ReactNode
  onClick?: () => void
}

export default function Card({ sx, children, onClick }: ICardProps) {
  return (
    <MUICard
      sx={{
        ...sx,
        cursor: onClick ? 'pointer' : 'default',
      }}
      variant="outlined"
      onClick={onClick}
    >
      {children}
    </MUICard>
  )
}
